export default (theme) => ({
  loginContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    bottom: 0,
    top: 0,
    right: 0,
  },
  loginCard: {
    width: 400,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: '100%',
    },
  },
  loginContent: {
    display: 'flex',
    // flexDirection: 'column',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  loginLogo: {
    color: theme.palette.primary.main,
    flexBasis: '100%',
    marginBottom: 25,
  },
  inputItem: {
    margin: '10px 0px',
    flexBasis: 350,
  },
  blockContainer: {
    flexBasis: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    margin: '5px 0px',
  },
  loginActions: {
    justifyContent: 'flex-end',
  },
  invisible: {
    visibility: 'hidden',
  },
});
